import { Scope, Severity } from "@sentry/browser";
import { SentryService } from "./sentry.service";
import { IMessageDialog } from "@qpUIs/qp-message-dialog/qp-message-dialog.interface";
import { envConfig } from "@env/env-config";

/**
 * 捕获未作处理的异常
 * @param sentryService 
 * @returns 
 */
function ExceptionHandler(sentryService: SentryService, $injector: angular.auto.IInjectorService) {

    //延迟异常提示
    let timeoutFn: any;
    //上一次的错误提示
    let lastMessage: string = "";
    //相同错误，多次提示的次数
    let lastTimes: number = 1;

    //检查多次相同的提交
    function checkLastMessage(msg: string): boolean {
        if (lastMessage == msg) {
            //相同提示连续出现10次，则不再提交
            if (lastTimes >= 10) {
                return false;
            }

            lastTimes += 1;
        } else {
            lastTimes = 1;
        }

        lastMessage = msg;

        return true;
    }

    return function exceptionHandlerFunc(exception: Error | string) {
        console.log("Sentry has got an unhandeld exception");
        console.log(exception);
        Sentry.withScope(sentryService.getScope("EXCEPTION_HANDLER", function (scope: Scope) {
            if (typeof exception == "string") {
                if (!checkLastMessage(exception)) {
                    return;
                }

                scope.setLevel(Severity.Fatal);
                scope.setExtra("errorType", "unresolved");
                Sentry.captureMessage("未知异常--" + exception);
            } else {
                if (!checkLastMessage(exception.message)) {
                    return;
                }

                scope.setLevel(Severity.Fatal);
                scope.setExtra("exception", exception);
                scope.setExtra("errorType", "unresolved");
                scope.setTransactionName("未知异常--" + exception.message || exception.name);

                Sentry.captureException(exception);

                //延迟异常提示，避免有些没处理确认逻辑，频繁持续弹出多个对话框
                if (!timeoutFn) {
                    timeoutFn = setTimeout(() => {
                        timeoutFn = null;

                        //错误标题和错误信息
                        let title: string;
                        let content: string;

                        if ($injector.has("$translate")) {
                            //多语言
                            let $translate = $injector.get<angular.translate.ITranslateService>("$translate");

                            title = $translate.instant("BASE_UNHANDLE_ERROR_TITLE");
                            content = $translate.instant("BASE_UNHANDLE_ERROR_CONTENT", { supportmail: envConfig.supportEmail });
                        } else {
                            //没有注入多语言时
                            console.error("你的模块没有注入多语言类库'angular-translate'")
                            title = "Unknown error occurred";
                            content = "Oops! An unknown error has occurred, please refresh the page and try again. If the problem still exists, please contact our technical support " + envConfig.supportEmail + ".";
                        }

                        lastTimes = 1;

                        //错误提示
                        if ($injector.has("qpMessageDialog")) {
                            let $dialog = $injector.get<IMessageDialog>("qpMessageDialog");

                            $dialog.error({
                                title: title,
                                content: content,
                                code: "S-001",
                                msg: exception.message
                            });
                        } else if (window.qpAlertPrompt && window.qpAlertPrompt.error) {
                            window.qpAlertPrompt.error(title, content);
                        } else {
                            alert(content);
                        }
                    }, 250);
                }
            }
        }));
    };
}

let injectableExceptionHandler = ['$sentry', '$injector', ExceptionHandler]

export { injectableExceptionHandler }